import { call, put, takeLatest, all } from "redux-saga/effects";
import { message } from "antd";

import {
  ACTIVATE_DEVICE,
  ACTIVATE_DEVICE_SUCCESS,
  ACTIVATE_DEVICE_ERROR,
  FETCH_DEVICE_ACT_INFO,
  FETCH_DEVICE_ACT_INFO_ERROR,
  FETCH_DEVICE_ACT_INFO_SUCCESS,
} from "../../actions/common/configurationAction";

import {
  activateDeviceAPI,
  fetchDeviceActAPI,
} from "../../../services/configuration-service";

function* fetchDeviceActInfo() {
  try {
    const response = yield call(fetchDeviceActAPI);

    if (response.success) {
      yield put({
        type: FETCH_DEVICE_ACT_INFO_SUCCESS,
        payload: response.data,
      });
    } else {
      message.error("Failed to fetch device activation info!");

      yield put({ type: FETCH_DEVICE_ACT_INFO_ERROR, error: response.error });
    }
  } catch (error) {
    message.error("Failed to fetch device activation info!");

    yield put({ type: FETCH_DEVICE_ACT_INFO_ERROR, error });
  }
}

function* activateDevice(activateDevice) {
  try {
    const response = yield call(activateDeviceAPI, activateDevice.payload);

    if (response.success) {
      yield put({
        type: ACTIVATE_DEVICE_SUCCESS,
        payload: response.data,
      });

      message.success("Device activated successfully!");
    } else {
      message.error("Failed to activate device. Please try again!");

      yield put({ type: ACTIVATE_DEVICE_ERROR, error: response.error });
    }
  } catch (error) {
    message.error("Failed to activate device!");

    yield put({ type: ACTIVATE_DEVICE_ERROR, error });
  }
}

function* deviceActivationWatcher() {
  yield takeLatest(FETCH_DEVICE_ACT_INFO, fetchDeviceActInfo);
  yield takeLatest(ACTIVATE_DEVICE, activateDevice);
}

export default function* rootSaga() {
  yield all([deviceActivationWatcher()]);
}
